import React from 'react';
import { NeonColor } from '@/services/enums';

interface NeonTextProps {
  children: React.ReactNode;
  className?: string;
  color?: NeonColor;
}

const NeonText: React.FC<NeonTextProps> = ({ children, className = '', color = 'cyan' }) => {
  const colorClasses = {
    cyan: 'text-cyan-400',
    purple: 'text-purple-400',
    pink: 'text-pink-400',
    green: 'text-green-400',
    blue: 'text-blue-400',
  };

  return (
    <span
      className={`
        ${colorClasses[color]}
        font-bold
        ${className}
      `}
    >
      {children}
    </span>
  );
};

export default NeonText;
